import { Component, OnInit, Renderer, OnDestroy } from '@angular/core';
import { ContactosService } from '../../services/contactos.service';
import { Contacto } from '../../interfaces/contactos.interface';

@Component({
  selector: 'app-listar',
  templateUrl: './listar.component.html',
  styles: []
})
export class ListarComponent implements OnInit, OnDestroy {
  contactos: Contacto[];
  constructor(private _cs: ContactosService, private renderer: Renderer) {
    this.renderer.setElementClass(document.body, 'paginas-internas', true);
    this._cs.getListar().subscribe( data => {
      this.contactos = data;
    });

  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.renderer.setElementClass(document.body, 'paginas-internas', false);
  }

}



// WEBPACK FOOTER //
// /Users/diego/Documents/SirisWebSite/WebSite/src/app/components/contacto/listar.component.ts